export function normalizeTurnArtifactMessages(messages = []) {
    const normalized = [];
    let currentTurn = null;

    const flushTurn = () => {
        if (currentTurn) {
            normalized.push(currentTurn);
            currentTurn = null;
        }
    };

    for (const msg of messages || []) {
        if (msg?.role === 'user') {
            flushTurn();
            currentTurn = {
                role: 'turn',
                _id: msg._id,
                createdAt: msg.createdAt,
                content: msg.content,
                metadata: {
                    ...(msg.metadata || {}),
                    userMessage: msg,
                    tools: [],
                    presentations: [],
                    assistantMessages: [],
                    traceIds: [],
                    blocks: [],
                },
            };
            continue;
        }

        if (msg?.role === 'tool_group') {
            const tools = Array.isArray(msg.metadata?.tools) ? msg.metadata.tools : [];
            if (currentTurn && tools.length > 0) {
                currentTurn.metadata.tools.push(...tools);
                const lastBlock = currentTurn.metadata.blocks[currentTurn.metadata.blocks.length - 1];
                if (lastBlock && lastBlock.type === 'tools') {
                    lastBlock.tools.push(...tools);
                } else {
                    currentTurn.metadata.blocks.push({ type: 'tools', tools: [...tools] });
                }
                continue;
            }
            flushTurn();
            normalized.push(msg);
            continue;
        }

        if (msg?.role === 'presentation') {
            if (currentTurn) {
                currentTurn.metadata.presentations.push(msg.metadata || {});
                currentTurn.metadata.blocks.push({ type: 'presentation', data: msg.metadata || {} });
                continue;
            }
            flushTurn();
            normalized.push(msg);
            continue;
        }

        if (msg?.role === 'assistant') {
            if (currentTurn) {
                const assistant = { ...msg, metadata: { ...(msg.metadata || {}) } };
                const inlineTools = Array.isArray(assistant.metadata.tools) ? assistant.metadata.tools : [];
                const inlinePresentations = Array.isArray(assistant.metadata.presentations) ? assistant.metadata.presentations : [];

                if (inlineTools.length > 0) {
                    currentTurn.metadata.tools.push(...inlineTools);
                }
                if (inlinePresentations.length > 0) {
                    currentTurn.metadata.presentations.push(...inlinePresentations);
                }

                delete assistant.metadata.tools;
                delete assistant.metadata.presentations;

                currentTurn.metadata.assistantMessages.push(assistant);
                if (Array.isArray(assistant.metadata.traceIds)) {
                    currentTurn.metadata.traceIds.push(...assistant.metadata.traceIds);
                }

                if (assistant.content) {
                    currentTurn.metadata.blocks.push({ type: 'assistant', message: assistant });
                }
                if (inlineTools.length > 0) {
                    currentTurn.metadata.blocks.push({ type: 'tools', tools: inlineTools });
                }
                if (inlinePresentations.length > 0) {
                    for (const pres of inlinePresentations) {
                        currentTurn.metadata.blocks.push({ type: 'presentation', data: pres });
                    }
                }
                continue;
            }
            flushTurn();
            normalized.push(msg);
            continue;
        }

        flushTurn();
        normalized.push(msg);
    }

    flushTurn();
    return normalized;
}
